import React from 'react';
import moment from 'moment';

import RequestIcon from '../assets/icons/RequestIcon';
import BookedIcon from '../assets/icons/BookedIcon';
import OverdueIcon from '../assets/icons/OverdueIcon';
import CompletedIcon from '../assets/icons/CompletedIcon';
import CancelIcon from '../assets/icons/CancelIcon';

import { getKeyByValue } from './utils';

import { caseStatusOptions, setAllocationStatuses } from '../constants/enums';
import { statusColors } from '../constants/cases';

const CASE_DELETE_ALLOCATED_SETS_WARNING = 'Sets are allocated to this order!\nYou cannot delete this case. Please return all shipped items, or deallocate items from the case before deleting the case.';

const hasAllocatedSetsForDelete = (setsAllocation = []) => setsAllocation.some((allocation) => (
  ![
    setAllocationStatuses.AVAILABLE.value,
    setAllocationStatuses.DISABLED.value,
  ].includes(allocation?.status)
));

const filterCases = (item, statusFilter, searchState, date, a) => {
  const statusKey = getKeyByValue(caseStatusOptions, item.status);

  return (item.id?.toLowerCase().includes(searchState.toLowerCase())
    || item.patientReference?.toLowerCase().includes(searchState.toLowerCase()))
    && !!statusFilter[statusKey]
    && (moment(item.date).isSame(date, 'day') || !date);
};

const getStatusIcon = (status, filled, canceled) => {
  if (canceled) {
    return <CancelIcon color={filled ? statusColors.OVERDUE : '#ffffff'} />;
  }

  switch (status) {
    case caseStatusOptions.request:
      return <RequestIcon color={filled ? statusColors.REQUEST : '#ffffff'} />;
    case caseStatusOptions.booked:
      return <BookedIcon color={filled ? statusColors.BOOKED : '#ffffff'} />;
    case caseStatusOptions.overdue:
      return <OverdueIcon color={filled ? statusColors.OVERDUE : '#ffffff'} />;
    case caseStatusOptions.completed:
      return <CompletedIcon color={filled ? statusColors.COMPLETED : '#ffffff'} />;
    default:
      return <RequestIcon color={filled ? statusColors.REQUEST : '#ffffff'} />;
  }
};

const getStatusLabel = (status, canceled) => {
  if (canceled) {
    return 'Canceled';
  }

  switch (status) {
    case caseStatusOptions.request:
      return 'Request';
    case caseStatusOptions.booked:
      return 'Booked';
    case caseStatusOptions.overdue:
      return 'Overdue';
    case caseStatusOptions.completed:
      return 'Completed';
    default:
      return 'Request';
  }
};

export {
  CASE_DELETE_ALLOCATED_SETS_WARNING,
  filterCases,
  getStatusIcon,
  getStatusLabel,
  hasAllocatedSetsForDelete,
};
